import axios from "axios";
import L, { control as lControl } from "leaflet";

export default {
  name: "ElementCoordinates",
  components: {
    editReadingComp: require("@/employee/captureMeterReadings/editReading.vue").default,
    backButton: require("@/components/backButton/backButton.vue").default,
  },
  props: {
    dataObj: {
      type: Object,
      //required: true,
    },
  },
  data: function () {
    return {
      isLoading: true,
      gisSettings: {},
      currentLocation: {
        lat: 0,
        lng: 0,
      },
      mapSettings: {
        map: null,
        zoom: 18,
        center: [],
        isRendering: false,
      },

      //markers: [],
      marker: null,
      currLocIcon: null,
      currentLocMarker: null,
      currentLocCircle: null,
      showMap: true,
      showInfoTable: true,

      markerIcon: L.icon({
        iconUrl: require("@/assets/images/meterReadings/location-red.svg"),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41],
      }),
    };
  },
  watch: {
    editReadingDataObj: function (val) {
      if (val) this.markCurrentReading();
    },
    marker: function (val) {
      this.dataObj.appData.coordinatesData = {
        lng: this.marker.connectionGpsX,
        lat: this.marker.connectionGpsY
      }
    }
  },
  computed: {
    getInfoClass: function () {
      return this.showInfoTable
        ? "map-button-info-icon-on"
        : "map-button-info-icon-off";
    },
  },
  created() {
    //{
    //  "lat": -89.99852656304863,
    //    "lng": -153.2792541530629,
    //      "z": 0
    //}
    this.marker = {
      connectionGpsX: this.dataObj.appData.coordinatesData.lng,
      connectionGpsY: this.dataObj.appData.coordinatesData.lat
    };
    navigator.geolocation.getCurrentPosition(this.getStartLocation, (err) => console.log(err));
  },
  mounted() {
    let temp = this.$localStorage.get("_map_info");
    this.showInfoTable = temp === "false" ? false : true;
  },
  methods: {
    getTopCss(item) {
      if (item == "info") return this.bigMap ? "top-490" : "top-200";
      else return this.bigMap ? "top-540" : "top-250";
    },
    showInfo() {
      this.showInfoTable = !this.showInfoTable;
      this.$localStorage.set("_map_info", this.showInfoTable);
    },
    getStartLocation(position) {
      this.currentLocation.lat = position.coords.latitude;
      this.currentLocation.lng = position.coords.longitude;

      this.currLocIcon = L.icon({
        iconUrl: require("@/assets/images/meterReadings/currentLocationMarker.png"),
        iconAnchor: [12, 41],
        popupAnchor: [12, -41],
      });

      this.mapSettings.center.push(
        position.coords.latitude,
        position.coords.longitude
      );
      this.getGisSettings();
    },
    getCurrentLocation(position) {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      if (lat == this.currentLocation.lat && lng == this.currentLocation.lng)
        return;

      this.currentLocation.lat = lat;
      this.currentLocation.lng = lng;

      this.mapSettings.map.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          if (layer.options.alt == "CurrentLocation")
            this.mapSettings.map.removeLayer(layer);
        }
      });

      L.marker([lat, lng], {
        icon: this.currLocIcon,
        alt: "CurrentLocation",
      }).addTo(this.mapSettings.map);
    },
    getGisSettings() {
      axios
        .post("/gis/GetGisSettings")
        .then((response) => {
          this.gisSettings = response.data;
          this.initMap(true);
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    initMap(zoomToMarker = false) {
      this.mapSettings.map = L.map(this.$refs.map).setView(
        this.mapSettings.center,
        this.mapSettings.zoom
      );

      let google = L.tileLayer(
        "http://{s}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}",
        {
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          attribution:
            '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          //maxZoom: 21,
          //minZoom: 11
        }
      );

      let osm = L.tileLayer(
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          //maxZoom: 21,
          //minZoom: 11
        }
      );

      let googleEarth = L.tileLayer(
        "https://{s}.google.com/vt?lyrs=s,h&x={x}&y={y}&z={z}",
        {
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          attribution:
            '&copy; <a href="https://www.google.com/maps/">Google Maps</a>',
          //maxZoom: 21,
          //minZoom: 11
        }
      );

      //default choice
      googleEarth.addTo(this.mapSettings.map);

      //remove leaflet attribution
      this.mapSettings.map.attributionControl.setPrefix("");

      this.currentLocMarker = L.marker(
        [this.currentLocation.lat, this.currentLocation.lng],
        {
          icon: this.currLocIcon,
          alt: "CurrentLocation",
        }
      ).addTo(this.mapSettings.map);

      //add all layers to map - overlayes not implemented
      (lControl.layers({
        OpenStreetMap: osm,
        "Google Map": google,
        "Google Earth": googleEarth,
      }) as any).addTo(this.mapSettings.map);

      setInterval(() => {
        navigator.geolocation.getCurrentPosition(this.getCurrentLocation);
      }, 5000);

      this.mapSettings.map.on("moveend", this.loadOnMove);
      this.mapSettings.map.on("click", this.onClicked);

      this.drawConnectionsMarkers();

      if (zoomToMarker)
        this.centerMap();

      this.isLoading = false;
    },
    loadOnMove() {
      this.mapSettings.isRendering = false;
      this.drawConnectionsMarkers();
    },
    onClicked(event) {
      if (this.dataObj.readOnly) {
        this.$oldAlertMsg(this.$t('common.ReadOnlyWarning'), 3);
        return;
      }        

      this.marker = {
        connectionGpsY: event.latlng.lat,
        connectionGpsX: event.latlng.lng,
      };
      this.drawConnectionsMarkers();
    },
    async drawConnectionsMarkers() {
      if (this.mapSettings.isRendering || !this.marker) return;

      this.mapSettings.isRendering = true;

      this.clearMarkers();

      const marker = L.marker(
        [this.marker.connectionGpsY, this.marker.connectionGpsX],
        {
          icon: this.markerIcon,
          alt: this.marker,
        }
      ).addTo(this.mapSettings.map);

      this.mapSettings.isRendering = false;
    },
    clearMarkers() {
      this.mapSettings.map.eachLayer((layer: L.Layer) => {
        if (layer instanceof L.Marker) {
          if (layer.options.alt !== "CurrentLocation") {
            this.mapSettings.map.removeLayer(layer);
          }
        }
      });
    },
    async centerMap() {
      await this.sleep(1);

      let loc = [];
      if (!this.marker.connectionGpsY && !this.marker.connectionGpsX && !this.currentLocation.lat && !this.currentLocation.lng)
          return;

      if (this.marker.connectionGpsY && this.marker.connectionGpsX)
        loc = [this.marker.connectionGpsY, this.marker.connectionGpsX];

      else if (this.currentLocation.lat && this.currentLocation.lng)
        loc = [this.currentLocation.lat, this.currentLocation.lng];      

      this.mapSettings.map.panTo(L.latLng([loc[0], loc[1]])).setZoom(19);
    },
    sleep(tm: number): Promise<void> {
      return new Promise<void>((resolve) => {
        setTimeout(resolve, tm);
      });
    },
  },
};
